/**
 * Image Utils
 */

import { find, isArray, isEmpty, random } from 'lodash';

const placeholders = [
  'https://orpheus-assets.s3.amazonaws.com/images/ams-image-placeholder.png',
  'https://orpheus-assets.s3.amazonaws.com/images/ams-image-placeholder-2.png',
];

export function getPlaceholderThumbnail() {
  return placeholders[random(0, placeholders.length - 1)];
}

export function getResponsivePlaceholderThumbnail(): IResponsiveImage {
  const path = placeholders[random(0, placeholders.length - 1)];
  return {
    blur: [{ format: 'png', metadata: { width: 512, height: 512 }, path }],
    small: [{ format: 'png', metadata: { width: 512, height: 512 }, path }],
    medium: [{ format: 'png', metadata: { width: 512, height: 512 }, path }],
    large: [{ format: 'png', metadata: { width: 512, height: 512 }, path }],
    xlarge: [{ format: 'png', metadata: { width: 512, height: 512 }, path }],
  };
}

export function getResponsiveAssets(
  type: 'thumb' | 'cover',
  assets: GQL.IAsset[],
  ...fallbackAssets: GQL.IAsset[][]
): IResponsiveImage {
  const imageAssets = assets.filter((asset) => asset.type === type);

  if (!imageAssets.length) {
    return !!fallbackAssets.length ?
      getResponsiveThumbnailAssets(fallbackAssets.shift()!, ...fallbackAssets)
      : getResponsivePlaceholderThumbnail();
  }

  const responsiveImage: Partial<IResponsiveImage> = {};

  imageAssets.reduce((acc, image) => {
    if (['small', 'medium', 'large', 'xlarge', 'blur'].indexOf(image.version!) > -1) {

      const imageData: IImageData = {
        format: image.file_format!,
        metadata: type === 'cover' ? image.metadata : undefined,
        path: `/${image.path!}`,
      };

      if (isArray(acc[image.version!])) {
        acc[image.version!].push(imageData);
      } else {
        acc[image.version!] = [imageData];
      }
    }

    return acc;
  }, responsiveImage);

  if (isEmpty(responsiveImage)) {
    return getResponsivePlaceholderThumbnail();
  }

  return responsiveImage as IResponsiveImage;
}

export function getResponsiveThumbnailAssets(
  assets: GQL.IAsset[],
  ...fallbackAssets: GQL.IAsset[][]
): IResponsiveImage {
  return getResponsiveAssets('thumb', assets, ...fallbackAssets);
}

export function getImagePathForSize(assets: IResponsiveImage, size: ThumbnailSize) {
  let imgSrc: string;
  const placeholder = getResponsivePlaceholderThumbnail();
  switch (size) {
    case 'xxlarge':
    case 'xlarge':
      const xlargeImg = find(assets.xlarge, ({ format }) => format !== 'webp');
      imgSrc = xlargeImg ? xlargeImg.path : placeholder.xlarge[0].path;
      break;
    case 'large':
      const largeImg = find(assets.large, ({ format }) => format !== 'webp');
      imgSrc = largeImg ? largeImg.path : placeholder.large[0].path;
      break;
    case 'medium':
    case 'small':
      const mediumImg = find(assets.medium, ({ format }) => format !== 'webp');
      imgSrc = mediumImg ? mediumImg.path : placeholder.medium[0].path;
      break;
    default:
      const smallImg = find(assets.small, ({ format }) => format !== 'webp');
      imgSrc = smallImg ? smallImg.path : placeholder.small[0].path;
      break;
  }

  return imgSrc;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/utils/image.ts